import { useCallback, useEffect, useState } from 'react';

const KEY = 'dashboard.showSatellites';

// Single global preference: hide shared-office satellite AFs from lists by
// default. Stored in localStorage so it persists across reloads, and broadcast
// via a "storage" event listener so toggles in one view update other views in
// the same tab too.
const EVENT = 'satellite-pref-change';

function read(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

export function useSatellitePreference(): [boolean, (next: boolean) => void] {
  const [show, setShow] = useState<boolean>(read);

  useEffect(() => {
    function onChange() {
      setShow(read());
    }
    window.addEventListener(EVENT, onChange);
    window.addEventListener('storage', onChange);
    return () => {
      window.removeEventListener(EVENT, onChange);
      window.removeEventListener('storage', onChange);
    };
  }, []);

  const update = useCallback((next: boolean) => {
    try {
      window.localStorage.setItem(KEY, next ? '1' : '0');
    } catch {
      // ignore (private mode etc.)
    }
    setShow(next);
    window.dispatchEvent(new Event(EVENT));
  }, []);

  return [show, update];
}
